import { useSelector } from "react-redux";
import { translate } from "./index";

/**
 * Translation hook. `const t = useT();` then `t("booking.vin")`.
 * Optional second arg is a fallback shown if the key is missing everywhere.
 */
export default function useT() {
    const lang = useSelector((state) => state.user.language) || "geo";
    return (key, fallback) => {
        const value = translate(lang, key);
        if (value === key && fallback !== undefined) return fallback;
        return value;
    };
}
